// 合作伙伴国际化配置文件
export default {
  cooperation: {
    label: {
      startDate: '申请日期从',
      endDate: '申请日期到',
      partnerType: '合作伙伴类型',
      // requestStatus: "申请单状态",
      partnerZhName: '合作伙伴名称',
      partnerCode: '合作伙伴编码',
      searchCode: '搜索简码',
      identityNo: '身份识别证件编号',
      creditCode: '统一社会信用代码',
      requestByName: '申请人',
      requestTime: '申请日期',
      companyCode: '公司代码',
      companyName: '公司名称',
      cooperation: '合作伙伴主数据',
      creditLimitAmount: '授信总金额',
      departmentCode: '业务部门',
      createBy: '创建人',
      requestBy: '申请人',
      ifDomestic: '国家地区',
      ifPersonalPartner: '个人合作伙伴',
      ifCreditPartner: '授信合作伙伴',
      yes: '是',
      no: '否',
      invoiceAddress: '开票地址',
      invoicePhone: '开票电话',
      invoiceBankName: '开票银行名称',
      invoiceBankAccount: '开票银行账号',
      legalPerson: '法人',
      legalEntityType: '法人类型',
      industryName: '行业',
      registeredAssets: '注册资本(万)',
      establishedDate: '成立日期',
      personnelIdentificationNumber: '人员识别号',
      enterpriseType: '企业类型',
      taxType: '发票类型',
      tradeCurrency: '交易币种',
      province: '省份',
      streetAddress: '街道地址',
      postCode: '邮编',
      mark: '备注',
      applyReason: '申请原因',
      extendRequestDepartment: '申请扩展部门',
      extendRequestPerson: '申请人',
      extendType: '扩展类型',
      bankName: '银行',
      bankCode: '银行代码',
      associatedLineNumber: '联行号',
      accountBankBranch: '开户分行',
      bankAccount: '银行账户',
      contactPersonName: '联系人',
      mobilePhone: '移动电话',
      telephone: '固定电话',
      faxNo: '传真号',
      email: '邮箱',
      address: '地址',
      attachmentName: '附件列表',
      sellAccountGroup: '账户组',
      sellReconciliationSubject: '对账科目',
      sellReconciliationSubjectEx: '销售对账科目',
      sellReceiptMethod: '收款方式',
      sellInvoiceCondition: '开票条件',
      procurementAccountGroup: '账户组',
      procurementReconciliationSubject: '对账科目',
      procurementReconciliationSubjectEx: '采购对账科目',
      procurementReceiptMethod: '收款方式',
      procurementPayMethod: '付款方式',
      procurementPayCondition: '付款条件',
      procurementCurrency: '订单货币',
      procurementDepositAmount: '保证金金额',
      partnerCodeOld: '原编码',
      partnerCodeNew: '改为',
      partnerParentCompanyCode: '所属集团编码',
      partnerParentCompanyName: '所属集团名称',
      partnerParentCompany: '所属集团',
      taxpayerType: '纳税人分类',
      partnerForm: '合作伙伴类别',
      requestStatus: '审批状态',
      auditReason: '审批原因',
      sureAuditReason: '确认审批',
      partnerEnName: '英文名称',
      capacityLimitAmount: '库存限额(万)',
    },
    placeholder: {
      auditReason: '审批原因',
      requestStatus: '请输入审批状态',
      taxpayerType: '请选择纳税人分类',
      partnerForm: '请选择合作伙伴类别',
      companyCode: '请输入公司代码',
      companyName: '请输入公司名称',
      departmentName: '请输入部门名称',
      requestTime: '请选择申请日期',
      partnerZhName: '请输入名称',
      searchPartnerZhName: '请选择名称',
      createBy: '请输入创建人',
      requestBy: '请输入申请人',
      searchCode: '请输入简码',
      partnerCode: '请输入合作伙伴编码',
      departmentCode: '请选择业务部门',
      ifDomestic: '请选择国家地区',
      ifCreditPartner: '请选择授信合作伙伴',
      ifPersonalPartner: '请选择个人合作伙伴',
      partnerType: '请选择合作伙伴类型',
      autoProduction: '自动生成',
      zh: '中文',
      en: '请输入英文名称',
      pleaseSelect: '请选择',
      creditCode: '请输入统一社会信用代码',
      identityNo: '请输入身份识别证件编号',
      invoiceAddress: '请输入开票地址',
      invoicePhone: '请输入开票电话',
      invoiceBankName: '请输入开票银行名称',
      invoiceBankAccount: '请输入开票银行账号',
      legalPerson: '请输入法人',
      legalEntityType: '请选择法人类型',
      industryName: '请选择行业',
      registeredAssets: '金额',
      currencyType: '币种',
      establishedDate: '请选择成立日期',
      personnelIdentificationNumber: '请输入人员识别号',
      enterpriseType: '请选择企业类型',
      taxType: '请选择发票类型',
      tradeCurrency: '请选择交易币种',
      province: '请选择省份',
      city: '请选择城市',
      streetAddress: '请输入街道地址',
      roomNo: '门牌号',
      postCode: '请输入邮政编码',
      mark: '请输入备注',
      applyReason: '请输入申请原因',
      extendType: '请选择扩展类型',
      extendRequestDepartment: '请选择扩展部门',
      sellAccountGroup: '请选择账户组',
      sellReconciliationSubject: '请选择对账科目',
      sellReconciliationSubjectDesc: '编码',
      sellReceiptMethod: '请选择收款方式',
      sellInvoiceCondition: '请选择开票条件',
      sellInvoiceConditionDesc: '请输入开票条件描述',
      procurementAccountGroup: '请选择账户组',
      procurementReconciliationSubject: '请选择科目代码',
      procurementReconciliationSubjectDesc: '描述',
      procurementReceiptMethod: '请选择收款方式',
      procurementPayMethod: '请选择付款方式',
      procurementPayCondition: '请选择付款条件',
      procurementPayConditionDesc: '请输入付款条件描述',
      procurementCurrency: '请选择订单货币',
      procurementDepositAmount: '请输入保证金金额',
      partnerCodeOld: '请输入原编码',
      partnerCodeNew: '请输入新编码',
      bankName: '请输入银行名称',
      bankCode: '请输入银行代码',
      associatedLineNumber: '请输入银联号',
      accountBankBranch: '请输入开户分行',
      bankAccount: '请输入银行账户',
      contactPersonName: '请输入联系人',
      mobilePhone: '请输入联系电话',
      telephone: '请输入固定电话',
      faxNo: '请输入传真号',
      email: '请输入邮箱',
      address: '请输入地址',
      partnerParentCompanyCode: '请选择所属集团',
      pleaseChangeOne: '只有审批中状态的数据可进行操作',
      capacityLimitAmount: '请输入',
    },
    route: {
      cooperation: '合作伙伴主数据',
      addCooperation: '新建合作伙伴主数据',
      editCooperation: '编辑合作伙伴主数据',
    },
    message: {
      noData: '您还未选择任何数据',
      pleaseSelectOne: '请选择一条数据操作',
      topFormCheckResult: '请您将数据填写完整',
      deleteSuccess: '删除成功',
      baseDataIncomplete: '请将基本数据填写完整',
      salesDataIncomplete: '请将销售数据填写完整',
      purchasingDataIncomplete: '请将采购数据填写完整',
      is_expand_apply: '数据已存在，是否扩展申请',
      expandApply: '扩展申请',
      return_list_page: '返回合作伙伴主数据页面',
      data_repeat: '已存在该数据',
      cancelled: '已取消',
      canNotChange: '该数据状态不可编辑',
      enable_to_forbid: '启用只针对已禁用的状态',
      forbid_to_enable: '禁用只针对已生效的状态',
      check_forbid_enable: '查重功能针对已生效, 已禁用的状态',
      merge_need_enable: '合并功能针对已生效的数据',
      checkrest: '数据重复',
      canNotSync: '该数据状态不可同步',
    },
    buttons: {
      add: '新增',
      export: '导出',
      forbid: '禁用',
      delete: '删除',
      enable: '启用',
      check: '查重',
      merge: '合并',
      import: '批量导入',
      importFile: '上传',
      clickImport: '点击上传',
      save: '保存',
      submit: '提交',
      seeOrEdit: '修改/显示',
      credit_limit_application: '信用额度申请',
      credit_limit_see: '信用额度查看',
      changeDepartment: '切换部门',
      cancel: '取 消',
      sure: '确 定',
      expand: '扩展',
    },
    tabsName: {
      baseData: '基本数据',
      salesData: '销售数据',
      purchasingData: '采购数据',
      mappingData: '系统映射关系',
      extendedInformation: '扩展信息',
    },
    dialogTitle: {
      checkResult: '查重结果',
      merge: '合并',
    },
    tableRequest: {
      requestByCode: '申请编号',
    },
    extendedTable: {
      company: '公司',
      department: '部门',
      cooperationType: '合作伙伴类型',
    },
  },
};
